import React from "react";
import StudentLogin from "./StudentPortal/StudentLogin";

const Home = () => {
  return (
    <div>
      <StudentLogin />
    </div>
  );
};

export default Home;
